export const NOTIFICATION_LISTENER_EXCEPTION = "0";
export const CONDITION_EVALUATOR_ERROR = "1";
export const EXPERIMENT_KEY_NOT_IN_DATAFILE = "2";
export const FEATURE_NOT_IN_DATAFILE = "3";
export const INVALID_ATTRIBUTES = "4";
export const INVALID_BUCKETING_ID = "5";
export const INVALID_DATAFILE = "6";
export const INVALID_DATAFILE_MALFORMED = "7";
export const INVALID_CONFIG = "8";
export const INVALID_JSON = "9";
export const INVALID_EVENT_TAGS = "10";
export const INVALID_EXPERIMENT_KEY = "11";
export const INVALID_EXPERIMENT_ID = "12";
export const INVALID_GROUP_ID = "13";
export const INVALID_USER_ID = "14";
export const INVALID_USER_PROFILE_SERVICE = "15";
export const MISSING_INTEGRATION_KEY = "16";
export const NO_DATAFILE_SPECIFIED = "17";
export const NO_JSON_PROVIDED = "18";
export const NO_EVENT_PROCESSOR = "19";
export const NO_VARIATION_FOR_EXPERIMENT_KEY = "20";
export const ODP_CONFIG_NOT_AVAILABLE = "21";
export const ODP_EVENT_FAILED = "22";
export const ODP_EVENTS_SHOULD_HAVE_ATLEAST_ONE_KEY_VALUE = "23";
export const ODP_MANAGER_MISSING = "24";
export const ODP_NOT_INTEGRATED = "25";
export const UNDEFINED_ATTRIBUTE = "26";
export const UNRECOGNIZED_ATTRIBUTE = "27";
export const UNABLE_TO_CAST_VALUE = "28";
export const USER_NOT_IN_FORCED_VARIATION = "29";
export const USER_PROFILE_LOOKUP_ERROR = "30";
export const USER_PROFILE_SAVE_ERROR = "31";
export const VARIABLE_KEY_NOT_IN_DATAFILE = "32";
export const VARIATION_ID_NOT_IN_DATAFILE = "33";
export const INVALID_INPUT_FORMAT = "34";
export const INVALID_DATAFILE_VERSION = "35";
export const INVALID_VARIATION_KEY = "36";
export const ERROR_FETCHING_DATAFILE = "37";
export const DATAFILE_FETCH_REQUEST_FAILED = "38";
export const EVENT_DATA_INVALID = "39";
export const EVENT_ACTION_INVALID = "40";
export const FAILED_TO_SEND_ODP_EVENTS = "41";
export const UNABLE_TO_GET_VUID_VUID_MANAGER_NOT_AVAILABLE = "42";
export const UNKNOWN_CONDITION_TYPE = "43";
export const UNKNOWN_MATCH_TYPE = "44";
export const UNRECOGNIZED_DECIDE_OPTION = "45";
export const NO_PROJECT_CONFIG_FAILURE = "46";
export const EVENT_KEY_NOT_FOUND = "47";
export const NOT_TRACKING_USER = "48";
export const VARIABLE_REQUESTED_WITH_WRONG_TYPE = "49";
export const UNEXPECTED_RESERVED_ATTRIBUTE_PREFIX = "50";
export const BUCKETING_ID_NOT_STRING = "51";
export const UNEXPECTED_CONDITION_VALUE = "52";
export const UNEXPECTED_TYPE = "53";
export const OUT_OF_BOUNDS = "54";
export const REQUEST_TIMEOUT = "55";
export const REQUEST_ERROR = "56";
export const NO_STATUS_CODE_IN_RESPONSE = "57";
export const INVALID_REQUEST_URL = "58";
export const UNSUPPORTED_PROTOCOL = "59";
export const RETRY_CANCELLED = "60";
export const ONLY_POST_REQUESTS_ARE_SUPPORTED = "61";
export const SEND_BEACON_FAILED = "62";
export const FAILED_TO_DISPATCH_EVENTS = "63";
export const ODP_EVENT_MANAGER_STOPPED = "64";
export const UNABLE_TO_ATTACH_UNLOAD = "65";
export const UNABLE_TO_PARSE_AND_SKIPPED_HEADER = "66";
export const CMAB_FETCH_FAILED = "67";
export const INVALID_CMAB_FETCH_RESPONSE = "68";
export const PROMISE_NOT_ALLOWED = "69";
export const SERVICE_NOT_RUNNING = "70";
export const EVENT_STORE_FULL = "71";
export const LOCAL_HOLDOUT_MISSING_INCLUDED_RULES = "72";
export const messages = [
    "Notification listener for (%s) threw exception: %s",
    "Error evaluating audience condition of type %s: %s",
    "Experiment key %s is not in datafile.",
    "Feature key %s is not in datafile.",
    "Provided attributes are in an invalid format.",
    "Unable to generate hash for bucketing ID %s: %s",
    "Datafile is invalid - property %s: %s",
    "Datafile is invalid because it is malformed.",
    "Provided Optimizely config is in an invalid format.",
    "JSON object is not valid.",
    "Provided event tags are in an invalid format.",
    "Experiment key %s is not in datafile. It is either invalid, paused, or archived.",
    "Experiment ID %s is not in datafile.",
    "Group ID %s is not in datafile.",
    "Provided user ID is in an invalid format.",
    "Provided user profile service instance is in an invalid format: %s.",
    "Integration key missing from datafile. All integrations should include a key.",
    "No datafile specified. Cannot start optimizely.",
    "No JSON object to validate against schema.",
    "No event processor is provided",
    "No variation key %s defined in datafile for experiment %s.",
    "ODP config is not available.",
    "ODP event send failed.",
    "ODP events should have at least one key-value pair in identifiers.",
    "ODP Manager is missing. %s failed.",
    "ODP is not integrated",
    "Provided attribute: %s has an undefined value.",
    "Unrecognized attribute %s provided. Pruning before sending event to Optimizely.",
    "Unable to cast value %s to type %s, returning null.",
    "User %s is not in the forced variation map. Cannot remove their forced variation.",
    "Error while looking up user profile for user ID \"%s\": %s.",
    "Error while saving user profile for user ID \"%s\": %s.",
    "Variable with key \"%s\" associated with feature with key \"%s\" is not in datafile.",
    "Variation ID %s is not in the datafile.",
    "Provided %s is in an invalid format.",
    "This version of the JavaScript SDK does not support the given datafile version: %s",
    "Provided variation key is in an invalid format.",
    "Error fetching datafile: %s",
    "Datafile fetch request failed with status: %s",
    "Event data invalid.",
    "Event action invalid.",
    "failed to send odp events",
    "Unable to get VUID - VuidManager is not available",
    "Audience condition %s has an unknown condition type. You may need to upgrade to a newer release of the Optimizely SDK.",
    "Audience condition %s uses an unknown match type. You may need to upgrade to a newer release of the Optimizely SDK.",
    "Unrecognized decide option %s provided.",
    "No project config available. Failing %s.",
    "Event key %s is not in datafile.",
    "Not tracking user %s.",
    "Requested variable type \"%s\", but variable is of type \"%s\". Use correct API to retrieve value. Returning None.",
    "Attribute %s unexpectedly has reserved prefix %s; using attribute ID instead of reserved attribute name.",
    "BucketingID attribute is not a string. Defaulted to userId",
    "Audience condition %s evaluated to UNKNOWN because the condition value is not supported.",
    "Audience condition %s evaluated to UNKNOWN because a value of type \"%s\" was passed for user attribute \"%s\".",
    "Audience condition %s evaluated to UNKNOWN because the number value for user attribute \"%s\" is not in the range [-2^53, +2^53].",
    "Request timeout",
    "Request error",
    "No status code in response",
    "Invalid request URL: %s",
    "Unsupported protocol: %s",
    "Retry cancelled",
    "Only POST requests are supported",
    "sendBeacon failed",
    "Failed to dispatch events, status: %s",
    "ODP event manager stopped before it could start",
    "unable to bind optimizely.close() to page unload event: \"%s\"",
    "Unable to parse & skipped header item",
    "CMAB decision fetch failed with status: %s",
    "Invalid CMAB fetch response",
    "Promise value is not allowed in sync operation",
    "%s not running",
    "Event store is full. Not saving event with id %d.",
    "Local holdout \"%s\" is missing or has empty \"includedRules\"; skipping."
];
//# sourceMappingURL=error_message.gen.js.map